import React from "react";

const CommentPopup = (props) => {
    return (
        <>
            <div className=" ViewComment " >
                <div>Comments</div>
                <div className="dflex flexd-column">
                    <span> {props.Comment} </span>
                <button className="Buttons" onClick={()=>props.CloseComment(false)}>Close</button></div>
            </div>
        </>
    )
};
export default CommentPopup;